<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Links' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <div class="conteudo-add">
    <ion-list *ngFor="let link of links;" class="conteudo-list">
      <ion-item class="list-item" (click)="openLink(link);">
        <ion-avatar slot="start">
          <i class="fas fa-globe-americas icon-link icon-list"></i>
        </ion-avatar>

        <p class="conteudo-mensagem bold-1">{{link.nome}}</p>

        <ion-note slot="end" class="item-icon">
          <ion-icon name="chevron-forward-outline" class="icon-list"></ion-icon>
        </ion-note>
      </ion-item>
    </ion-list>
  </div>

  <ion-list *ngIf="links.length == 0">
    <sem-registro></sem-registro>
  </ion-list>
</ion-content>
